import React from 'react';
import {
  DropDown, PrimaryButton, SearchInput, Pulse, SecondaryButton, TextInput
} from 'wf-react-component-library';
import ItemApi from '../api/virs/ItemApi';
import CategoryGroupApi from '../api/p3/CategoryGroupApi';
import CategoryGroupCommodityApi from '../api/p3/CategoryGroupCommodityApi';
import CategoryGroupCommodityVarietyApi from '../api/p3/CategoryGroupCommodityVarietyApi';
import CategoryGroupCommoditySubcommodityApi from '../api/p3/CategoryGroupCommoditySubcommodityApi';
import CategoryGroupSubgroup1Api from '../api/p3/CategoryGroupSubgroup1Api';
import CategoryGroupSubgroup2Api from '../api/p3/CategoryGroupSubgroup2Api';
import CategoryMethodApi from '../api/p3/CategoryMethodApi';
import CategoryCertificationApi from '../api/p3/CategoryCertificationApi';
import CategoryBrandApi from '../api/p3/CategoryBrandApi';
import { getItemsByCriteria, getItemsByItemCodes } from '../api/p3/ItemApi';
import { getItemsByVendorCode } from '../services/api/VIRSApiService';
import fromP3Item from '../services/data-transform/VirmItem';
import { validateShortItem } from '../services/validation/VirmItem';
import PulseModal from './PulseModal';
import ErrorModal from './ErrorModal';

import './AddItemModal.scss';

const CRITERIA_CATEGORY = 'category';
const CRITERIA_GROUP = 'group';
const CRITERIA_METHOD = 'method';
const CRITERIA_CERTIFICATION = 'certification';
const CRITERIA_BRAND = 'brand';
const CRITERIA_COMMODITY = 'commodity';
const CRITERIA_SUBGROUP1 = 'misc';
const CRITERIA_SUBGROUP2 = 'grade';
const CRITERIA_VARIETY = 'variety';
const CRITERIA_TYPE = 'type';

const CRITERIA = [CRITERIA_CATEGORY, CRITERIA_GROUP, CRITERIA_METHOD,
  CRITERIA_CERTIFICATION, CRITERIA_BRAND, CRITERIA_COMMODITY, CRITERIA_SUBGROUP1,
  CRITERIA_SUBGROUP2, CRITERIA_VARIETY, CRITERIA_TYPE];

class AddItemModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchItems: [],
      selectedItems: [],
      items: [],
      dropdowns: {},
      isLoadingP3Items: false,
      displayNoItemsFoundMsg: false,
      isLoadingSearchCriteria: false,
      isLoadingGroupSearchCriteria: false,
      isLoadingCommoditySearchCriteria: false,
      isSavingItems: false,
      errorMsg: '',
      noItemsSelected: false,
      displaySelectACategoryMsg: false,
      displayEnterItemIdsMsg: false,
      selectAllChecked: false,
      isLoadingItemSearch: false,
      itemSearchCriteria: '',
      isAvailableFilterOn: false,
      isUnavailableFilterOn: false
    };

    this.closeModal = this.closeModal.bind(this);
    this.handleDropDownChange = this.handleDropDownChange.bind(this);
    this.updateDropDown = this.updateDropDown.bind(this);
    this.updateSelectedItemsInDropDown = this.updateSelectedItemsInDropDown.bind(this);
    this.getOptionsFromDetails = this.getOptionsFromDetails.bind(this);
    this.handleSearchChange = this.handleSearchChange.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.getP3ItemsBySearchCriteria = this.getP3ItemsBySearchCriteria.bind(this);
    this.handleResetSearchCriteria = this.handleResetSearchCriteria.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.handleSelectedItemToAdd = this.handleSelectedItemToAdd.bind(this);
    this.removeErrorMessages = this.removeErrorMessages.bind(this);
    this.handleSelectAll= this.handleSelectAll.bind(this);
    this.handleItemIdSearchCriteria = this.handleItemIdSearchCriteria.bind(this);
    this.getP3ItemsByItemIds = this.getP3ItemsByItemIds.bind(this);
    this.handleResetSearchByItemIds = this.handleResetSearchByItemIds.bind(this);
    this.handleFilterByAvailability = this.handleFilterByAvailability.bind(this);
  }

  componentDidMount = () => {
    const dropdowns = {};
    dropdowns[CRITERIA_CATEGORY] = {
      options: this.props.categories, details: this.props.categoryDetails, selectedId: '', selectedValue: '',
    };
    CRITERIA.forEach((criteria) => {
      if (criteria !== CRITERIA_CATEGORY) {
        dropdowns[criteria] = {
          options: {}, details: [], selectedId: '', selectedValue: '',
        };
      }
    });
    getItemsByVendorCode(this.props.vendorCode).then(resp => {
      this.setState({ dropdowns, vendorCode: this.props.vendorCode, vendorItems: resp });
    })
  }

  // ---------------------------- BEGIN: GPP-1479 GET P3 ITEMS BY SEARCH CRITERIA -------------------------

  handleDropDownChange = async (e) => {
    const selectedDropDown = e.target.name;
    const selectedValue = e.target.value;

    const { dropdowns } = this.state;
    let selectedId = this.state.dropdowns[selectedDropDown] ? this.state.dropdowns[selectedDropDown].selectedId : '';
    const options = this.state.dropdowns[selectedDropDown] ? this.state.dropdowns[selectedDropDown].options : {};
    const details = this.state.dropdowns[selectedDropDown] ? this.state.dropdowns[selectedDropDown].details : [];
    let categoryId;

    switch (selectedDropDown) {
      case CRITERIA_CATEGORY:
        this.setState({ isLoadingSearchCriteria: true, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false });

        selectedId = dropdowns[CRITERIA_CATEGORY].details.filter((category) => category.name === selectedValue)[0].categoryId;
        this.updateDropDown(dropdowns, CRITERIA_CATEGORY, selectedId, details, options, selectedValue);

        try {
          const groupDetails = await CategoryGroupApi.getCategoryGroups(selectedId);
          const groupOptions = this.getOptionsFromDetails(groupDetails, 'description');
          this.updateDropDown(dropdowns, CRITERIA_GROUP, '', groupDetails, groupOptions, '');
        } catch {
          this.updateDropDown(dropdowns, CRITERIA_GROUP, '', [], {}, '');
        }

        try {
          const methodDetails = await CategoryMethodApi.getCategoryMethods(selectedId);
          const methodOptions = this.getOptionsFromDetails(methodDetails, 'name');
          this.updateDropDown(dropdowns, CRITERIA_METHOD, '', methodDetails, methodOptions, '');
        } catch {
          this.updateDropDown(dropdowns, CRITERIA_METHOD, '', [], {}, '');
        }

        try {
          const certDetails = await CategoryCertificationApi.getCategoryCertifications(selectedId);
          const certOptions = this.getOptionsFromDetails(certDetails, 'name');
          this.updateDropDown(dropdowns, CRITERIA_CERTIFICATION, '', certDetails, certOptions, '');
        } catch {
          this.updateDropDown(dropdowns, CRITERIA_CERTIFICATION, '', [], {}, '');
        }

        try {
          const brandDetails = await CategoryBrandApi.getCategoryBrands(selectedId);
          const brandOptions = this.getOptionsFromDetails(brandDetails, 'name');
          this.updateDropDown(dropdowns, CRITERIA_BRAND, '', brandDetails, brandOptions, '');
        } catch {
          this.updateDropDown(dropdowns, CRITERIA_BRAND, '', [], {}, '');
        }

        this.updateDropDown(dropdowns, CRITERIA_COMMODITY, '', [], {}, '');
        this.updateDropDown(dropdowns, CRITERIA_SUBGROUP1, '', [], {}, '');
        this.updateDropDown(dropdowns, CRITERIA_SUBGROUP2, '', [], {}, '');
        this.updateDropDown(dropdowns, CRITERIA_VARIETY, '', [], {}, '');
        this.updateDropDown(dropdowns, CRITERIA_TYPE, '', [], {}, '');

        this.setState({
          displaySelectACategoryMsg: false, displayEnterItemIdsMsg: false, dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false
        });
        break;
      case CRITERIA_GROUP:
        this.setState({ isLoadingGroupSearchCriteria: true, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false });
        categoryId = dropdowns[CRITERIA_CATEGORY].selectedId;
        selectedId = selectedValue !== '' ? details.filter((group) => group.description === selectedValue)[0].code : '';
        var groupId = selectedValue !== '' ? details.filter((group) => group.description === selectedValue)[0].groupId : '';

        this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_GROUP, selectedId, selectedValue);

        if (groupId === '') {
          // clear all the data from commmodity, subgroup1, and subgroup2
          this.updateDropDown(dropdowns, CRITERIA_COMMODITY, '', [], {}, '');
          this.updateDropDown(dropdowns, CRITERIA_SUBGROUP1, '', [], {}, '');
          this.updateDropDown(dropdowns, CRITERIA_SUBGROUP2, '', [], {}, '');
        } else {
          try {
            const commodityDetails = await CategoryGroupCommodityApi.getCategoryGroupCommodities(categoryId, groupId);
            const commodityOptions = this.getOptionsFromDetails(commodityDetails, 'description');
            this.updateDropDown(dropdowns, CRITERIA_COMMODITY, '', commodityDetails, commodityOptions, '');
          } catch {
            this.updateDropDown(dropdowns, CRITERIA_COMMODITY, '', [], {}, '');
          }

          try {
            const subGroup1Details = await CategoryGroupSubgroup1Api.getCategoryGroupSubgroup1(categoryId, groupId);
            const subGroup1Options = this.getOptionsFromDetails(subGroup1Details, 'name');
            this.updateDropDown(dropdowns, CRITERIA_SUBGROUP1, '', subGroup1Details, subGroup1Options, '');
          } catch {
            this.updateDropDown(dropdowns, CRITERIA_SUBGROUP1, '', [], {}, '');
          }

          try {
            const subGroup2Details = await CategoryGroupSubgroup2Api.getCategoryGroupSubgroup2(categoryId, groupId);
            const subGroup2Options = this.getOptionsFromDetails(subGroup2Details, 'name');
            this.updateDropDown(dropdowns, CRITERIA_SUBGROUP2, '', subGroup2Details, subGroup2Options, '');
          } catch {
            this.updateDropDown(dropdowns, CRITERIA_SUBGROUP2, '', [], {}, '');
          }
        }

        this.updateDropDown(dropdowns, CRITERIA_VARIETY, '', [], {}, '');
        this.updateDropDown(dropdowns, CRITERIA_TYPE, '', [], {}, '');

        this.setState({
          dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, isLoadingGroupSearchCriteria: false,
        });
        break;
      case CRITERIA_METHOD:
        selectedId = selectedValue !== '' ? details.filter((method) => method.name === selectedValue)[0].methodId : '';
        this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_METHOD, selectedId, selectedValue);
        this.setState({
          dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false
        });
        break;
      case CRITERIA_CERTIFICATION:
        selectedId = selectedValue !== '' ? details.filter((method) => method.name === selectedValue)[0].certificationId : '';
        this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_CERTIFICATION, selectedId, selectedValue);
        this.setState({
          dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false
        });
        break;
      case CRITERIA_BRAND:
        selectedId = selectedValue !== '' ? details.filter((method) => method.name === selectedValue)[0].brandId : '';
        this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_BRAND, selectedId, selectedValue);
        this.setState({
          dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false
        });
        break;
      case CRITERIA_COMMODITY:
        this.setState({ isLoadingCommoditySearchCriteria: true, selectAllChecked: false });
        categoryId = dropdowns[CRITERIA_CATEGORY].selectedId;
        const groupSelectedValue = dropdowns[CRITERIA_GROUP].selectedValue;
        groupId = groupSelectedValue !== '' ? dropdowns[CRITERIA_GROUP].details.filter((group) => group.description === groupSelectedValue)[0].groupId : '';
        selectedId = selectedValue !== '' ? details.filter((method) => method.description === selectedValue)[0].commodityId : '';

        this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_COMMODITY, selectedId, selectedValue);

        if (selectedId === '') {
          // clear all the data from commmodity, subgroup1, and subgroup2
          this.updateDropDown(dropdowns, CRITERIA_VARIETY, '', [], {}, '');
          this.updateDropDown(dropdowns, CRITERIA_TYPE, '', [], {}, '');
        } else {
          try {
            const varietyDetails = await CategoryGroupCommodityVarietyApi.getCategoryGroupCommodityVarieties(categoryId, groupId, selectedId);
            const varietyOptions = this.getOptionsFromDetails(varietyDetails, 'name');
            this.updateDropDown(dropdowns, CRITERIA_VARIETY, '', varietyDetails, varietyOptions, '');
          } catch {
            this.updateDropDown(dropdowns, CRITERIA_VARIETY, '', [], {}, '');
          }

          try {
            const typeDetails = await CategoryGroupCommoditySubcommodityApi.getCategoryGroupCommoditySubcommodities(categoryId, groupId, selectedId);
            const typeOptions = this.getOptionsFromDetails(typeDetails, 'name');
            this.updateDropDown(dropdowns, CRITERIA_TYPE, '', typeDetails, typeOptions, '');
          } catch {
            this.updateDropDown(dropdowns, CRITERIA_TYPE, '', [], {}, '');
          }
        }

        this.setState({
          dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, isLoadingCommoditySearchCriteria: false,
        });
        break;
      case CRITERIA_SUBGROUP1:
        selectedId = selectedValue !== '' ? details.filter((method) => method.name === selectedValue)[0].code : '';
        this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_SUBGROUP1, selectedId, selectedValue);
        this.setState({
          dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false
        });
        break;
      case CRITERIA_SUBGROUP2:
        selectedId = selectedValue !== '' ? details.filter((method) => method.name === selectedValue)[0].code : '';
        this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_SUBGROUP2, selectedId, selectedValue);
        this.setState({
          dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false
        });
        break;
      case CRITERIA_VARIETY:
        selectedId = selectedValue !== '' ? details.filter((method) => method.name === selectedValue)[0].name : '';
        this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_VARIETY, selectedId, selectedValue);
        this.setState({
          dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false
        });
        break;
      case CRITERIA_TYPE:
        selectedId = selectedValue !== '' ? details.filter((method) => method.name === selectedValue)[0].name : '';
        this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_TYPE, selectedId, selectedValue);
        this.setState({
          dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false
        });
        break;
      default:
        break;
    }
  }

  getOptionsFromDetails = (details, fieldName) => {
    const options = {};

    details.sort((a, b) => (a[fieldName] > b[fieldName] ? 1 : -1));
    details.forEach((detail) => {
      const value = detail[fieldName];
      options[value] = value;
    });

    return options;
  }

  updateSelectedItemsInDropDown = (dropdowns, selectedDropDown, selectedId, selectedValue) => {
    dropdowns[selectedDropDown].selectedId = selectedId;
    dropdowns[selectedDropDown].selectedValue = selectedValue;

    return dropdowns;
  }

  updateDropDown = (dropdowns, selectedDropDown, selectedId, details, options, selectedValue) => {
    dropdowns[selectedDropDown].selectedId = selectedId;
    dropdowns[selectedDropDown].selectedValue = selectedValue;
    dropdowns[selectedDropDown].details = details;
    dropdowns[selectedDropDown].options = options;

    return dropdowns;
  }

  getP3ItemsByItemIds = async () => {
    this.setState({ isLoadingP3Items: true });
    const { itemSearchCriteria, vendorItems} = await this.state;
    console.log(vendorItems);
    let burdenIds = new Set();
    for (const item of vendorItems){
      burdenIds.add(item.itemId);
    }

    if (itemSearchCriteria.length === 0) {
      this.setState({
        displaySelectACategoryMsg: false, isLoadingP3Items: false, displayEnterItemIdsMsg: true
      });
    } else {
      try {
        const resp = await getItemsByItemCodes(itemSearchCriteria.replace(/ /g, ''), 'someApiToken');
        const cleanResults = resp.reduce((prev, current) => {
          if (!(burdenIds.has(current.itemCode) && ((current?.commodityId === 147 && current?.itemGroupCode === 'M')
            || (current?.commodityId === 188 && current?.itemGroupCode === 'MB')
            || (current?.commodityId === 174 && current?.itemGroupCode === 'SB')))) {
            prev.push(current);
          }
          return prev;
        }, [])
        this.setState({
          items: cleanResults, searchItems: cleanResults, isLoadingP3Items: false, displayNoItemsFoundMsg: false, displaySelectACategoryMsg: false, displayEnterItemIdsMsg: false
        });
      } catch (err) {
        this.setState({
          items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: true, displaySelectACategoryMsg: false, displayEnterItemIdsMsg: false
        });
      }
    }
  }

  getP3ItemsBySearchCriteria = async () => {
    this.setState({ isLoadingP3Items: true });

    const { dropdowns, vendorItems } = this.state;
    const criteria = {};
    console.log(vendorItems);
    let burdenIds = new Set();
    for (const item of vendorItems){
      if (item.isBurdenItem){
        burdenIds.add(item.itemId);
      }
    }
    console.log(burdenIds);

    for (const [key, details] of Object.entries(dropdowns)) {
      if ((key === CRITERIA_CATEGORY || key === CRITERIA_GROUP) && details.selectedId) {
        criteria[key] = details.selectedId;
      } else if (details.selectedId) {
        criteria[key] = details.selectedValue;
      }
    }

    if (Object.keys(criteria).length === 0 ) {
      this.setState({
        displaySelectACategoryMsg: true, isLoadingP3Items: false, displayEnterItemIdsMsg: false
      })
    } else {
      try {
        const resp = await getItemsByCriteria(criteria, 'someApiToken');
        const cleanResults = resp.reduce((prev, current) => {
          if (!(burdenIds.has(current.itemCode) && ((current?.commodityId === 147 && current?.itemGroupCode === 'M')
            || (current?.commodityId === 188 && current?.itemGroupCode === 'MB')
            || (current?.commodityId === 174 && current?.itemGroupCode === 'SB')))) {
            prev.push(current);
          }
          return prev;
        }, [])
        console.log(cleanResults);
        this.setState({
          items: cleanResults, searchItems: cleanResults, isLoadingP3Items: false, displayNoItemsFoundMsg: false, displaySelectACategoryMsg: false, displayEnterItemIdsMsg: false
        });
      } catch (err) {
        this.setState({
          items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: true, displaySelectACategoryMsg: false, displayEnterItemIdsMsg: false
        });
      }
    }
  }

  handleResetSearchByItemIds = () => {
    this.setState({
      itemSearchCriteria: '', items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false
    });
  }

  handleResetSearchCriteria = () => {
    const { dropdowns } = this.state;

    this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_GROUP, '', '');
    this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_METHOD, '', '');
    this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_CERTIFICATION, '', '');
    this.updateSelectedItemsInDropDown(dropdowns, CRITERIA_BRAND, '', '');

    this.updateDropDown(dropdowns, CRITERIA_COMMODITY, '', [], {}, '');
    this.updateDropDown(dropdowns, CRITERIA_SUBGROUP1, '', [], {}, '');
    this.updateDropDown(dropdowns, CRITERIA_SUBGROUP2, '', [], {}, '');
    this.updateDropDown(dropdowns, CRITERIA_VARIETY, '', [], {}, '');
    this.updateDropDown(dropdowns, CRITERIA_TYPE, '', [], {}, '');

    this.setState({
      dropdowns, items: [], searchItems: [], isLoadingP3Items: false, displayNoItemsFoundMsg: false, isLoadingSearchCriteria: false, selectAllChecked: false, isAvailableFilterOn: true, isUnavailableFilterOn: true
    });
  }

  // ---------------------------- END: GPP-1479 GET P3 ITEMS BY SEARCH CRITERIA -------------------------

  closeModal = () => {
    const { items } = this.state;
    this.setState({
      searchItems: items,
      selectedCategory: []
    });
    this.props.closeModal();
  }

  handleItemIdSearchCriteria = (e) => {
    const itemSearchCriteria = e.target.value;
    if (itemSearchCriteria.length !== 0) {
      this.setState({ displayEnterItemIdsMsg: false });
    }
    this.setState({ itemSearchCriteria, displayNoItemsFoundMsg: false });
  }

  handleSelectedItemToAdd = (e) => {
    const currentItem = e.target.value.toString();
    let { selectedItems } = this.state;
    if (this.state.selectedItems.includes(currentItem)) {
      // remove from the array
      selectedItems = this.state.selectedItems.filter((item) => item !== currentItem);
      this.setState({ selectedItems, selectAllChecked: false });
    } else {
      selectedItems.push(currentItem);
      this.setState({
        selectedItems, selectAllChecked: false, actionErrorMsg: '', selectedAction: 0, noItemsSelected: false,
      });
    }
  }

  handleSelectAll = () => {
    const { selectAllChecked, searchItems } = this.state;
    if (selectAllChecked) {
      this.setState({ selectedItems: [], selectAllChecked: false, selectedAction: '' });
    } else {
      const selectedItems = searchItems.map((item) => item.itemId.toString());
      this.setState({
        selectAllChecked: true, selectedItems, actionErrorMsg: '', selectedAction: '',
      });
    }
  }

  handleSearchChange = (e) => {
    const searchCriteria = e.target.value;
    let searchItems = [];
    const { items } = this.state;
    if (searchCriteria.length > 2) {
      // check for comma separated search input.
      if (searchCriteria.includes(',')) {
        searchCriteria.split(',')
          .map((item) => item.trim())
          .forEach((searchTerm) => {
            searchItems.push(items.filter((item) => item.itemCode.toString().includes(searchTerm)
              || (item.description != null && item.description.toLowerCase()
                .includes(searchTerm.toLowerCase()))));
          });

        this.setState({ searchItems, selectAllChecked: false });
      } else {
        searchItems = items.filter((item) => item.itemCode.toString().includes(searchCriteria)
          || (item.description != null && item.description.toLowerCase()
            .includes(searchCriteria.toLowerCase())));

        this.setState({ searchItems, selectAllChecked: false });
      }
    } else {
      this.setState({ searchItems: this.state.items });
    }
  }

  clearSearch = () => this.setState({ searchItems: this.state.items, selectAllChecked: false, isAvailableFilterOn: false, isUnavailableFilterOn: false });

  handleSave = async () => {
    let { selectedItems, errorMsg, vendorItems} = this.state;
    let { currentUser } = this.props;

    if (selectedItems.length > 0) {
      this.setState({ isSavingItems: true });
      try {
        for (const itemId of selectedItems) {
          const items = this.state.items.filter((item) => item.itemId.toString() === itemId);
          if (items.length > 0) {
            const virmItem = fromP3Item(items[0]);
            virmItem.createdBy = currentUser;
            virmItem.modifiedBy = currentUser;
            virmItem.vendorId = this.state.vendorCode;
            const { errors } = validateShortItem(virmItem);
            if (errors === null) {
              this.handleSelectedItemToAdd({ target: { value: items[0].itemId } });
              await ItemApi.post(virmItem.vendorId, virmItem);
              //hide added burden items to prevent duplicate adds
              vendorItems.push(virmItem);
              if (virmItem.isBurdenItem) {
                let {items, searchItems} = this.state
                console.log(searchItems);
                this.setState({items: items.filter((item) => item.itemId.toString() != itemId), searchItems: searchItems.filter((item) => item.itemId.toString() != itemId)})
              }
            } else {
              console.log(`errors trying to save ${items[0].itemCode} = ${items[0].description}`);
              console.log(errors);
              console.log(`post body ${JSON.stringify(virmItem)}`);
              errorMsg += `errors trying to save ${items[0].itemCode} = ${items[0].description}`;
              errorMsg += '\n \n';
              errorMsg += `       ${JSON.stringify(errors)}`;
              errorMsg += '\n \n';
            }
          }
        }

        if (errorMsg.length > 0) {
          this.setState({ errorMsg, isSavingItems: false, vendorItems: vendorItems});
        } else {
          this.setState({ errorMsg: '', isSavingItems: false, selectAllChecked: false, vendorItems: vendorItems });
        }
      } catch (err) {
        console.log('error calling post');
        console.log(err);
        this.setState({ errorMsg: `There was an issue saving items for this vendor:  ${JSON.stringify(err)}`, isSavingItems: false });
      }
    } else {
      this.setState({ noItemsSelected: true });
    }
  }

  handleFilterByAvailability = (option) => {
    // 0 => Available
    // 1 => Unavailable
    const { isAvailableFilterOn, isUnavailableFilterOn, searchItems, items } = this.state;
    let newSearchItems;
    const availableFilterOn = option === 0 ? !isAvailableFilterOn : isAvailableFilterOn;
    const unavailableFilterOn = option === 1 ? !isUnavailableFilterOn: isUnavailableFilterOn;

    if (availableFilterOn && unavailableFilterOn) {
      newSearchItems = items;
    } else if (!availableFilterOn && unavailableFilterOn) {
      newSearchItems = searchItems.filter(item => item.availableFlag === false);
    } else if (availableFilterOn && !unavailableFilterOn) {
      newSearchItems = searchItems.filter(item => item.availableFlag === true);
    } else {
      newSearchItems = items;
    }

    this.setState({ isUnavailableFilterOn: unavailableFilterOn, isAvailableFilterOn: availableFilterOn, searchItems: newSearchItems });
  }

  removeErrorMessages = () => this.setState({ errorMsg: '' });

  render() {
    if (!this.state.dropdowns[CRITERIA_CATEGORY]) return null;

    const summaryCounts = this.state.searchItems.length === this.state.items.length
      ? `${this.state.items.length} Total Items`
      : `Search Returned ${this.state.searchItems.length} of ${this.state.items.length} Total Items`;

    const categoryId = this.state.dropdowns[CRITERIA_CATEGORY].selectedId;

    const commodityLabel = categoryId === 2 ? 'Species' : 'Commodity';

    // subgroup1  (UI name is Misc) and for Meat (UI name is Feed) and for Seafood (UI name is Count)
    const subgroup1Label = categoryId === 2
      ? 'Feed'
      : (categoryId === 1 ? 'Count' : 'Misc');

    // subgroup2 (UI name is Grade) and for Seafood (UI name is Farm/Wild)
    const subgroup2Label = categoryId === 1
      ? 'Farm/Wild'
      : 'Grade';

    const varietyLabel = categoryId === 2
      ? 'Cut'
      : 'Variety';

    const typeLabel = categoryId === 1
      ? 'Preparation'
      : 'Type';

    const items = this.state.searchItems.map((item) => {
      const checkbox = {};
      const altName = this.state.selectedItems.includes(item.itemId.toString()) ? "checked-item" : "unchecked-item";
      const classname = this.state.selectedItems.includes(item.itemId.toString()) ? "checked-item" : "unchecked-item";
      checkbox[item.itemId] = '';
      const itemRowClassName = 'item-row';
      return (
        <tr key={item.itemId} className={itemRowClassName}>
          <td>
            <div className="checkbox-container" key={item.id}>
              <label className="body-short-form">
                <input alt={altName} className={classname} data-testid={`checkbox-${item.itemId}`}  type="checkbox" value={item.itemId} checked={this.state.selectAllChecked || this.state.selectedItems.includes(item.itemId.toString())} onChange={this.handleSelectedItemToAdd} />
                <span />
              </label>
            </div>
          </td>
          <td style={{textAlign: 'center', paddingLeft: '0px'}}>
            { item.availableFlag
              ? "Available"
              : <span style={{color:"red"}}>Unavailable</span>
            }
          </td>
          <td>
            <span className="body-short-form">{item.itemCode}</span>
          </td>
          <td>
            <span className="body-short-form">{item.description}</span>
          </td>
        </tr>
      );
    });

    return (
      <div className="flex-container-row add-items">
        <div className="flex-container-row item-details-container show">

          <div className="flex-container-row search-criteria">
            <div className="flex-container-column" style={{width: '550px'}}>
              <TextInput labelName="Search By Item Code(s)" id="itemids" value={this.state.itemSearchCriteria} handleChange={this.handleItemIdSearchCriteria} placeHolderText="Enter a comma separated list of Item Code(s)" />
            </div>
            { (this.state.isLoadingItemSearch)
              ? <div className="flex-container-column"><Pulse text="Loading Search Criteria..." /></div>
              : (
                <div className="flex-container-column">
                  <div className="flex-container-row search-buttons">
                    <PrimaryButton onClick={this.getP3ItemsByItemIds} name="Search" />
                    <PrimaryButton onClick={this.handleResetSearchByItemIds} name="Reset" />
                  </div>
                </div>
              )}
          </div>

          <div className="flex-container-row search-criteria">
            <div className="flex-container-column">
              <DropDown id={CRITERIA_CATEGORY} labelName="Category" options={this.state.dropdowns[CRITERIA_CATEGORY].options} placeHolderText="Select a Category" handleChange={this.handleDropDownChange} />
            </div>

            { !this.state.isLoadingSearchCriteria && this.state.dropdowns[CRITERIA_GROUP].details.length > 0
              ? (
                <div className="flex-container-column">
                  <DropDown id={CRITERIA_GROUP} labelName="Group" value={this.state.dropdowns[CRITERIA_GROUP].selectedValue} options={this.state.dropdowns[CRITERIA_GROUP].options} placeHolderText="Select a Group" handleChange={this.handleDropDownChange} />
                </div>
              )
              : null}

            { !this.state.isLoadingGroupSearchCriteria && this.state.dropdowns[CRITERIA_COMMODITY].details.length > 0
              ? (
                <div className="flex-container-column">
                  <DropDown id={CRITERIA_COMMODITY} labelName={commodityLabel} value={this.state.dropdowns[CRITERIA_COMMODITY].selectedValue} options={this.state.dropdowns[CRITERIA_COMMODITY].options} placeHolderText={`Select a ${commodityLabel}`} handleChange={this.handleDropDownChange} />
                </div>
              )
              : null}

            { !this.state.isLoadingCommoditySearchCriteria && this.state.dropdowns[CRITERIA_VARIETY].details.length > 0
              ? (
                <div className="flex-container-column">
                  <DropDown id={CRITERIA_VARIETY} labelName={varietyLabel} value={this.state.dropdowns[CRITERIA_VARIETY].selectedValue} options={this.state.dropdowns[CRITERIA_VARIETY].options} placeHolderText={`Select a ${varietyLabel}`} handleChange={this.handleDropDownChange} />
                </div>
              )
              : null}

            { !this.state.isLoadingCommoditySearchCriteria && this.state.dropdowns[CRITERIA_TYPE].details.length > 0
              ? (
                <div className="flex-container-column">
                  <DropDown id={CRITERIA_TYPE} labelName={typeLabel} value={this.state.dropdowns[CRITERIA_TYPE].selectedValue} options={this.state.dropdowns[CRITERIA_TYPE].options} placeHolderText={`Select a ${typeLabel}`} handleChange={this.handleDropDownChange} />
                </div>
              )
              : null}

            { !this.state.isLoadingGroupSearchCriteria && this.state.dropdowns[CRITERIA_SUBGROUP1].details.length > 0
              ? (
                <div className="flex-container-column">
                  <DropDown id={CRITERIA_SUBGROUP1} labelName={subgroup1Label} value={this.state.dropdowns[CRITERIA_SUBGROUP1].selectedValue} options={this.state.dropdowns[CRITERIA_SUBGROUP1].options} placeHolderText={`Select a ${subgroup1Label}`} handleChange={this.handleDropDownChange} />
                </div>
              )
              : null}

            { !this.state.isLoadingGroupSearchCriteria && this.state.dropdowns[CRITERIA_SUBGROUP2].details.length > 0
              ? (
                <div className="flex-container-column">
                  <DropDown id={CRITERIA_SUBGROUP2} labelName={subgroup2Label} value={this.state.dropdowns[CRITERIA_SUBGROUP2].selectedValue} options={this.state.dropdowns[CRITERIA_SUBGROUP2].options} placeHolderText={`Select a ${subgroup2Label}`} handleChange={this.handleDropDownChange} />
                </div>
              )
              : null}

            { !this.state.isLoadingSearchCriteria && this.state.dropdowns[CRITERIA_METHOD].details.length > 0
              ? (
                <div className="flex-container-column">
                  <DropDown id={CRITERIA_METHOD} labelName="Method" value={this.state.dropdowns[CRITERIA_METHOD].selectedValue} options={this.state.dropdowns[CRITERIA_METHOD].options} placeHolderText="Select a Method" handleChange={this.handleDropDownChange} />
                </div>
              )
              : null}

            { !this.state.isLoadingSearchCriteria && this.state.dropdowns[CRITERIA_CERTIFICATION].details.length > 0
              ? (
                <div className="flex-container-column">
                  <DropDown id={CRITERIA_CERTIFICATION} labelName="Certification" value={this.state.dropdowns[CRITERIA_CERTIFICATION].selectedValue} options={this.state.dropdowns[CRITERIA_CERTIFICATION].options} placeHolderText="Select a Certification" handleChange={this.handleDropDownChange} />
                </div>
              )
              : null}

            { !this.state.isLoadingSearchCriteria && this.state.dropdowns[CRITERIA_BRAND].details.length > 0
              ? (
                <div className="flex-container-column">
                  <DropDown id={CRITERIA_BRAND} labelName="Brand" value={this.state.dropdowns[CRITERIA_BRAND].selectedValue} options={this.state.dropdowns[CRITERIA_BRAND].options} placeHolderText="Select a Brand" handleChange={this.handleDropDownChange} />
                </div>
              )
              : null}

            { (this.state.isLoadingGroupSearchCriteria || this.state.isLoadingCommoditySearchCriteria || this.state.isLoadingSearchCriteria)
              ? <div className="flex-container-column"><Pulse text="Loading Search Criteria..." /></div>
              : (
                <div className="flex-container-column">
                  <div className="flex-container-row search-buttons">
                    <PrimaryButton onClick={this.getP3ItemsBySearchCriteria} name="Search" />
                    <PrimaryButton onClick={this.handleResetSearchCriteria} name="Reset" />
                  </div>
                </div>
              )}

          </div>

          <div className="flex-container-row">

            { this.state.isLoadingP3Items
              ? <div className="flex-container-row"><Pulse text="Getting Items from P3..." /></div>
              : null}

            { this.state.displayNoItemsFoundMsg
              ? <div className="flex-container-row no-items headline-small">No Items Found</div>
              : null}

            { this.state.displaySelectACategoryMsg
              ? <div className="flex-container-row no-items headline-small">Select a Category to Search for Items</div>
              : null
            }

            { this.state.displayEnterItemIdsMsg
              ? <div className="flex-container-row no-items headline-small">You have not entered any Item Codes to search by</div>
              : null
            }

            { this.state.items.length > 0
              ? (
                <div className="flex-container-row">
                  <div className="flex-container-row add-item-table-container show">
                    <div className="flex-container-row search-container">
                      <div className="flex-container-column" style={{"width": "100%"}}>
                        <div className="flex-container-row add-item-count">
                          <div className="flex-container-column">
                            <div className="flex-container-row">
                              <div className="flex-container-column">
                                <SearchInput id="item-search" clearSearch={this.clearSearch} handleChange={this.handleSearchChange} placeHolderText="Search By Item Code or Description" />
                              </div>
                              <div className="flex-container-column">
                                  <button className={this.state.isAvailableFilterOn ? "available-filter" : "available-filter not-filtered"} onClick={() => this.handleFilterByAvailability(0)}>
                                    { this.state.isAvailableFilterOn ? "Available" : "Show Available" }
                                  </button>
                              </div>
                              <div className="flex-container-column">
                                  <button className={this.state.isUnavailableFilterOn ? "available-filter" : "available-filter not-filtered"} onClick={() => this.handleFilterByAvailability(1)}>
                                    { this.state.isUnavailableFilterOn ? "Unavailable" : "Show Unavailable" }
                                  </button>
                              </div>
                            </div>   
                          </div>
                          
                          <div className="flex-container-column">
                            <PrimaryButton onClick={this.handleSave} name="Add Selected Items" />
                            { this.state.noItemsSelected
                              ? <div className="error-msg">You have not selected any items to add.</div>
                              : null}    
                          </div>             
                        </div>                                      
                      </div>                    
                    </div>
                    <div className="flex-container-row item-counts">
                        <div className="container-row">{summaryCounts}</div>
                    </div>
                    <div className="item-table add">
                      <table className="item-table" cellPadding="0" cellSpacing="0" width="100%">
                        <colgroup>
                          <col span="1" style={{ width: '5%' }} />
                          <col span="1" style={{ width: '5%' }} />
                          <col span="1" style={{ width: '10%' }} />
                          <col span="1" style={{ width: '30%' }} />
                        </colgroup>

                        <tbody>
                          <tr className="item-table-header">
                            <td>
                              <div className="checkbox-container" key={1}>
                                <label className="body-short-form" htmlFor="allItems">
                                  <input data-testid="select-all-items" type="checkbox" id="allItems" value="1" checked={this.state.selectAllChecked} onChange={this.handleSelectAll} />
                                  <span />
                                </label>
                              </div>
                            </td>
                            <td className="available-column">
                             P3 Status
                            </td>
                            <td>Item Code</td>
                            <td>Full Description</td>
                          </tr>
                          {items}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div className="flex-container-row action-buttons">
                    { this.state.noItemsSelected
                      ? <div className="error-msg">You have not selected any items to add.</div>
                      : null}
                    <PrimaryButton onClick={this.handleSave} name="Add Selected Items" />
                    <SecondaryButton onClick={this.closeModal} name="Return to Dashboard" />
                  </div>
                </div>
              )
              : null}
          </div>

          { this.state.isSavingItems
            ? <PulseModal showPulseModal={this.state.isSavingItems} />
            : null}

          { this.state.errorMsg.length > 0
            ? <ErrorModal showErrorModal={this.state.errorMsg.length > 0} errorMessages={this.state.errorMsg} closeModal={this.removeErrorMessages} />
            : null}
        </div>
      </div>
    );
  }
}

export default AddItemModal;
